import { render, staticRenderFns } from "./ResearchGroupApplicants.html?vue&type=template&id=2a6ae376&scoped=true&"
import script from "./ResearchGroupApplicants.vue?vue&type=script&lang=js&"
export * from "./ResearchGroupApplicants.vue?vue&type=script&lang=js&"
import style0 from "./ResearchGroupApplicants.scss?vue&type=style&index=0&id=2a6ae376&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6ae376",
  null
  
)

export default component.exports